import React, { useContext, useEffect } from "react";
import styles from './AppList.module.scss'
import Link from "next/link";
import StackListItem from "./components/StackListItem";
import { store } from "../../../redux/store";
import { wipeModalState } from "../../../redux/actions/ModalActions";
import { connect } from "react-redux";
import { BUILDER_DATA } from "../../../settings/content/deploymentStacker";
import { UIContext } from "../../../layouts/app/components/UiHandler";
import { NAV_REQUEST_STACK } from "../../../settings/navigation";

function AppList({
                     apps, type, plans, loading,
                     // redux
                     height, width
                 }) {


    const {scrollY} = useContext(UIContext)?.scroll;

    useEffect(() => {
        return () => {store.dispatch(wipeModalState())};
    }, []);

    const withGroupLayout = (title, content, key) => {
        return (
            <div className={styles.list__group} key={key}>
                <p className={styles.list__group__title}>{title}</p>
                <ul className={styles.list__apps}>{content}</ul>
            </div>
        )
    };

    const renderApp = (app, index) => (
        <StackListItem
            app={app}
            plans={plans}
            apps={apps}
            // redux
            height={height}
            width={width}
            //context
            scrollY={scrollY}
            key={index}
        />
    )

    const builder = <StackListItem custom app={BUILDER_DATA} plans={plans}/>;

    switch (true) {
        case loading:
            return null;
        case !apps?.length:
            return (
                <div className={styles.list__empty}>
                    <p>No items found so far</p>
                    <p>Do we miss something?<Link href={NAV_REQUEST_STACK}> Request a stack</Link></p>
                </div>
            );
        case type === 'sort':
            return (
                <ul className={styles.list__apps}>
                    {builder}
                    {apps.map((app, index) => renderApp(app, index))}
                </ul>
            );
        case type === 'group':
            return (
                <>
                    {withGroupLayout('Stack Builder by TryDirect', builder)}
                    {
                        apps.map((app, index) => withGroupLayout(
                                app.criterion,
                                app.data && app.data.map((item, index) => renderApp(item, index)),
                                index
                            )
                        )
                    }
                </>
            )
    }
}

const mapStateToProps = state => ({
    width: state.UI.layoutDimensions.width,
    height: state.UI.layoutDimensions.height,
});

export default connect(mapStateToProps)(AppList)